// A roly-poly toy on a round, weighted bottom. Its tilt is two angles (about
// z, so it leans toward +x, and about x, toward +z). Gravity on the low
// centre of mass pulls it upright like a pendulum, and the round bottom rolls
// without slipping, so the body shifts by radius × angle as it leans. A poke
// tips it away from the finger; a held finger leans it over. It counts every
// fall past 55° that ends with it standing again (nana-korobi ya-oki).
const FALL=.96,UP=.14;
export class RolyPoly{
  constructor({radius,height,falls=7}){this.radius=radius;this.height=height;this.need=falls;this.reset();}
  reset(){this.tilt=[0,0];this.spin=[0,0];this.target=null;this.down=false;this.rises=0;this.wished=false;}
  get offset(){return [this.radius*this.tilt[0],this.radius*this.tilt[1]];}
  // A poke at a point (toy space, relative to the base centre) pushes the top away.
  poke(point){
    const k=4.2/this.height;
    this.spin[0]-=point[0]*k*Math.min(1,point[1]/this.height+.3);this.spin[1]-=point[2]*k*Math.min(1,point[1]/this.height+.3);
  }
  hold(angles){this.target=[...angles];}
  release(){this.target=null;}
  step(dt){
    const events=[],g=9/this.height;
    for(let a=0;a<2;a++){
      let acc=-g*Math.sin(this.tilt[a])-1.1*this.spin[a];
      if(this.target)acc=(this.target[a]-this.tilt[a])*140-this.spin[a]*22;
      this.spin[a]+=acc*dt;this.tilt[a]+=this.spin[a]*dt;
      this.tilt[a]=Math.max(-1.45,Math.min(1.45,this.tilt[a]));
    }
    const lean=Math.hypot(...this.tilt);
    if(Math.abs(this.spin[0])+Math.abs(this.spin[1])>1.2&&Math.sign(this.tilt[0])!==Math.sign(this.tilt[0]-this.spin[0]*dt))events.push('rock');
    if(!this.down&&lean>FALL){this.down=true;events.push('fall');}
    if(this.down&&!this.target&&lean<UP){
      this.down=false;this.rises++;events.push('rise');
      if(this.rises>=this.need&&!this.wished){this.wished=true;events.push('wish');}
    }
    if(!this.target&&lean<1e-4&&Math.hypot(...this.spin)<1e-3){this.tilt=[0,0];this.spin=[0,0];}
    return events;
  }
  get busy(){return !!this.target||Math.hypot(...this.tilt)>1e-4||Math.hypot(...this.spin)>1e-3;}
}
